// extracted by mini-css-extract-plugin
export default {"commonBtn":"CommonButton_commonBtn__p6j3R"};